import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { EnterView } from "core/classes/enter-view";

$(document).ready(function() {
	let cached = null/*, isInViewport = function(element) {
		 const rect = element.getBoundingClientRect();
		 return (
			  rect.top >= 0 &&
			  rect.left >= 0 &&
			  rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			  rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		 );
	}*/, isScrolledIntoView = function(element)
	{
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();
		 return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
	}, isSourceScrolledIntoView = function(image,child)
	{
		  var rectImage = image.getBoundingClientRect();
		  var rectChild = child.getBoundingClientRect();
		  return ((rectImage.top+rectChild.height <= rectChild.top) && (rectImage.top+rectImage.height > rectChild.top+rectChild.height) && (rectChild.top > 0 && rectChild.top > 0));
	};
	window.addEventListener('scroll', function(event){
	  if (!cached) {
		 setTimeout(function(){
			let hasGalleryStyle1 = false, hasGalleryStyle2 = false, hasGalleryStyle3 = false;
			$('.spin-scroll-gallery').each(function(index,elem){
				$('.hero-gallery', elem).each(function(idx, el){
					var sourceEls = $('.source',el);
					if(isScrolledIntoView(el)){
						$(el).addClass('is-visible');
						// document.body.classList.add("gallery-is-visible","gallery-style-2-is-visible");
						hasGalleryStyle2 = true;
					} else {
						$(el).removeClass('is-visible');
						// document.body.classList.remove("gallery-is-visible","gallery-style-2-is-visible");
					}
					sourceEls.each(function(idxsource,elsource){
						if(isSourceScrolledIntoView(el,elsource)&&$(el).hasClass('is-visible')&&(idxsource == sourceEls.length-1)){
							$(el).addClass('is-source-visible');
						} else {
							$(el).removeClass('is-source-visible');
						}
					});
				});
				$(window).trigger("abacus:gallerystyletwo:proccessed", [elem,event,index]);
			});
			$('.style1-gallery').each(function(index,elem){
				// $('.hero-gallery', elem).each(function(idx, el){
					//if(isScrolledIntoView(el)){
					if(isScrolledIntoView(elem)){
						hasGalleryStyle1 = true;
						return false;
					}
				// });
			});
			$('.style3-gallery').each(function(index,elem){
				// $('.hero-gallery', elem).each(function(idx, el){
					//if(isScrolledIntoView(el)){
					if(isScrolledIntoView(elem)){
						hasGalleryStyle3 = true;
						return false;
					}
				// });
			});
			if(hasGalleryStyle1||hasGalleryStyle2||hasGalleryStyle3){
				document.body.classList.add("gallery-is-visible");
			}else{
				document.body.classList.remove("gallery-is-visible");
			}
			if(hasGalleryStyle1){
				document.body.classList.add("gallery-style-1-is-visible");
			}else{
				document.body.classList.remove("gallery-style-1-is-visible");
			}
			if(hasGalleryStyle2){
				document.body.classList.add("gallery-style-2-is-visible");
			}else{
				document.body.classList.remove("gallery-style-2-is-visible");
			}
			if(hasGalleryStyle3){
				document.body.classList.add("gallery-style-3-is-visible");
			}else{
				document.body.classList.remove("gallery-style-3-is-visible");
			}
			cached = null;
		 }, 100)
	  }
	  cached = event;
	});
});

class LongformGalleriesStyleOne extends Class {
  constructor(element, mqp, options) {
    super();
    this.setOptions({
		selector: "",
		enter: () => {},
		exit: () => {},
		progress: () => {},
		offset: 0,
		once: false
	  }, options);
    this.setupEvents();
  }

  setupEvents() {
	var self = this;
	const updateSlides = (elem,idx) => {
        const indexElem = $(elem).closest(".galleryscroll"), img = indexElem.find(`.image[data-index='${idx}']`);
        if(img.length ){
			img.addClass("active");
			indexElem.find(".image.active").not(img).removeClass("active");
		}else{
			indexElem.find(".image.active").removeClass("active");
		}
	};
	new EnterView({
		selector: ".storytext .inline_gallery .galleryscroll .trigger",
		enter: this.debounce( (elem) => {
			const index = +elem.getAttribute("data-index");
			elem.classList.add("is-visible");
			// document.body.classList.add("gallery-is-visible","gallery-style-1-is-visible");
			updateSlides(elem, index);
		}
		, 200),
		exit: this.debounce( (elem) => {
			let index = +elem.getAttribute("data-index");
			index = Math.max(0, index - 1);
			elem.classList.remove("is-visible");
			// document.body.classList.remove("gallery-is-visible","gallery-style-1-is-visible");
			updateSlides(elem, index);
		}
		, 200)
	});
	$(".storytext .inline_gallery .galleryscroll").addClass("initialized").find(".image:first-of-type").addClass("active");
  }

  debounce(func, wait, options) {
		var lastArgs,
			lastThis,
			result,
			timerId,
			lastCallTime = 0,
			lastInvokeTime = 0,
			leading = false,
			maxWait = false,
			trailing = true;

		if (typeof func != 'function') {
			throw new TypeError('Expected a function');
		}
		//wait = toNumber(wait) || 0;
		wait = Number(wait) || 0;
		//if (isObject(options)) {
		if(typeof options === 'object' && options !== null){
			leading = !!options.leading;
			// maxWait = 'maxWait' in options && Math.max(toNumber(options.maxWait) || 0, wait);
			// trailing = 'trailing' in options ? !!options.trailing : trailing;
		}

		function now(){
			var dateNow = new Date();
			return dateNow.getTime();
		}

		function invokeFunc(time) {
			var args = lastArgs,
				thisArg = lastThis;

			lastArgs = lastThis = undefined;
			lastInvokeTime = time;
			result = func.apply(thisArg, args);
			return result;
		}

		function leadingEdge(time) {
			// Reset any `maxWait` timer.
			lastInvokeTime = time;
			// Start the timer for the trailing edge.
			timerId = setTimeout(timerExpired, wait);
			// Invoke the leading edge.
			return leading ? invokeFunc(time) : result;
		}

		function remainingWait(time) {
			var timeSinceLastCall = time - lastCallTime,
				timeSinceLastInvoke = time - lastInvokeTime,
				result = wait - timeSinceLastCall;

			return maxWait === false ? result : Math.min(result, maxWait - timeSinceLastInvoke);
		}

		function shouldInvoke(time) {
			var timeSinceLastCall = time - lastCallTime,
				timeSinceLastInvoke = time - lastInvokeTime;

			// Either this is the first call, activity has stopped and we're at the
			// trailing edge, the system time has gone backwards and we're treating
			// it as the trailing edge, or we've hit the `maxWait` limit.
			return (!lastCallTime || (timeSinceLastCall >= wait) || (timeSinceLastCall < 0) || (maxWait !== false && timeSinceLastInvoke >= maxWait));
		}

		function timerExpired() {
			var time = now();
			if (shouldInvoke(time)) {
				return trailingEdge(time);
			}
			// Restart the timer.
			timerId = setTimeout(timerExpired, remainingWait(time));
		}

		function trailingEdge(time) {
			clearTimeout(timerId);
			timerId = undefined;

			// Only invoke if we have `lastArgs` which means `func` has been
			// debounced at least once.
			if (trailing && lastArgs) {
				return invokeFunc(time);
			}
			lastArgs = lastThis = undefined;
			return result;
		}

		function cancel() {
			if (timerId !== undefined) {
				clearTimeout(timerId);
			}
			lastCallTime = lastInvokeTime = 0;
			lastArgs = lastThis = timerId = undefined;
		}

		function flush() {
			return timerId === undefined ? result : trailingEdge(now());
		}

		function debounced() {
			var time = now(),
				isInvoking = shouldInvoke(time);

			lastArgs = arguments;
			lastThis = this;
			lastCallTime = time;

			if (isInvoking) {
				if (timerId === undefined) {
					return leadingEdge(lastCallTime);
				}
				// Handle invocations in a tight loop.
				clearTimeout(timerId);
				timerId = setTimeout(timerExpired, wait);
				return invokeFunc(lastCallTime);
			}
			return result;
		}
		debounced.cancel = cancel;
		debounced.flush = flush;
		return debounced;
	}
}

export { LongformGalleriesStyleOne };


// WEBPACK FOOTER //
// ./Javascript/core/classes/longform-galleries.js